// ----------------------------------------------------------------------------
// Snippet: Breadcrumbs
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_breadcrumbs.scss';